// Admin - Dashbaord.

import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavBar from '../../lib-ui/admin/NavBar';
import Alert from '@mui/material/Alert';
import Util from '../../lib/Util';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


// import {useNavigate} from 'react-router-dom';



// Graph.
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import UIString from '../../assets/content/UIString';

//기본 Line 차트
//https://react-chartjs-2.js.org/examples/line-chart

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
export const options = {
  maintainAspectRatio: false,
  //responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
      align: 'start'
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July']; //x축 기준

export const data = {
  labels,
  datasets: [
    {
      borderWidth: 1,
      label: 'Android', //그래프 분류되는 항목
      data: [1, 2, 3, 4, 5, 6, 7], //실제 그려지는 데이터(Y축 숫자)
      borderColor: 'rgb(255, 200, 0)', //그래프 선 color
      backgroundColor: 'rgba(255, 200, 0, 0.5)', //마우스 호버시 나타나는 분류네모 표시 bg
    },
    {
      borderWidth: 1,
      label: 'iOS',
      data: [2, 3, 4, 5, 4, 7, 8],
      borderColor: 'rgb(255, 180, 0)', //실제 그려지는 데이터(Y축 숫자)
      backgroundColor: 'rgba(255, 180, 0, 0.5)',
    },
  ],
};







// Data table.
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];


export default () => {

  const lang = Util.get_lang();
  const [navTitle,setNavTitle] = useState('');

 // const navigate = useNavigate();
  useEffect(() => {

    setNavTitle( [UIString[lang]['NAV_DASHBOARD']] );

  });

  const post_test = () => {

    /*      
          let form  =new URLSearchParams;
          form.append('email','dev06.choi@gmail.com');
          form.append('password','00000000');
          Util.post('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login',form,(ret)=>{},(err)=>{});
          */

    const t = new Date().getTime();
    Util.get('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile?t=' + t, null, (ret) => { }, (err) => { });

    /*
    axios.post('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login', {
      key1: 'value1',
      key2: 'value2',
  })
  .then(response => {
      console.log('Success:', response.data);
  })
  .catch(error => {
      console.error('Error:', error);
  });
   */


    /*
        let form  =new FormData;
        form.append('email','dev06.choi@gmail.com');
        form.append('password','00000000');
    
        const formData = new URLSearchParams();
        formData.append('email','dev06.choi@gmail.com');
        formData.append('password','00000000');
    
        axios.post('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login',formData,
          {
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              withCredentials: true // Config.FLAG_REQUEST_SSL
          })
          .then(function (response) { 
            console.log('67',response);
          })
          .catch(function(err){});
    */

    /*
    axios.get('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile',{
    
      withCredentials: true // Config.FLAG_REQUEST_SSL
    } )
      .then(function (response) { 
        console.log('67',response);
      })
      .catch(function(err){  alert('error'); });
    */

    /*
    fetch('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile', {
      method: "GET",
       credentials: 'include', // 'include', 'same-origin', or 'omit'
    })
      .then((response) => { console.log('response LOGIN: ',response); })
    */

    /*
    const formData = new URLSearchParams();
    formData.append('email','dev06.choi@gmail.com');
    formData.append('password','00000000');
    
          
          fetch('https://www-dev.angeltrip.co/ko/api/v1/admin/auth/login', {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData,
          })
            .then((response) => { console.log('response LOGIN: ',response); })
    
            
    
    
    
    
    
    
    
            fetch('https://www-dev.angeltrip.co/ko/api/v1/admin/account/profile', {
              method: "GET",
               credentials: 'include', // 'include', 'same-origin', or 'omit'
            })
              .then((response) => { console.log('response LOGIN: ',response); })
    */
  }


  const nav_menu = [

    <Typography sx={{ fontSize: '13px' }}>
      User & Sales
    </Typography>,
  ];

  const nav_links = [{ label: 'Home', url: '/ko/admin/dashboard' }, { label: 'Dashboard', url: '/Dashboard' }];

  return (
    <>
      <Header code={'dashboard'} />
      <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px', textAlign: 'center', backgroundColor: '#ffffff', margin: '0px auto' }}>
        <Stack  className='page_title'  direction={'row'}>
          <NavBar text={navTitle} key={navTitle} />
        </Stack>

        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '12px', backgroundColor: '#ffffff' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{ /*navigate(Config.BASE_URL + '/admin/user')*/ }}>▪ User</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} />

          <div style={{ width: '100%', height: '300px', marginTop: '16px', marginBottom: '16px' }}><Line options={options} data={data} width={'100%'} /></div>
          Total: 16,220,700<br /><br />
          {/*<Alert severity="error" size={"small"} sx={{height:'33px',display:'flex',alignItems:'center'}}>This is an error Alert.</Alert>*/}
          {/*<Stack sx={{ width: '100%' }} spacing={0.4}>
            <Alert severity="success">This is a success Alert.</Alert>
            <Alert severity="info">This is an info Alert.</Alert>
            <Alert severity="warning">This is a warning Alert.</Alert>
            <Alert severity="error" size={"small"} sx={{height:'33px',display:'flex',alignItems:'center'}}>This is an error Alert.</Alert>
            <Alert severity="error" variant={"filled"} sx={{height:'33px',display:'flex',alignItems:'center'}} size={"small"}>This is an error Alert.</Alert>
          </Stack>*/}
        </Paper>
        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '12px' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{ /*navigate(Config.BASE_URL + '/admin/mobile_app')*/}}>▪ Mobile App</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} />
          <div style={{ width: '100%', height: '300px', marginTop: '16px', marginBottom: '16px' }}><Line options={options} data={data} width={'100%'} /></div>
          Total: 16,220,700<br /><br />
          Android: 16,220,700<br /><br />
          iOS: 16,220,700<br /><br />
        </Paper>
        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '12px' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{/*navigate(Config.BASE_URL + '/admin/post')*/}}>▪ Post</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} />
          <div style={{ width: '100%', height: '300px', marginTop: '16px', marginBottom: '16px' }}><Line options={options} data={data} width={'100%'} /></div>
          Photo: 16,220,700<br /><br />
          Video: 16,220,700<br /><br />
          Article: 16,220,700<br /><br />

        </Paper>
        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{/*navigate(Config.BASE_URL + '/admin/inquiry/user')*/}}>▪ User Inquiry</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} /><br />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Dessert (100g serving)</TableCell>
                  <TableCell align="right">Calories</TableCell>
                  <TableCell align="right">Fat&nbsp;(g)</TableCell>
                  <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                  <TableCell align="right">Protein&nbsp;(g)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.calories}</TableCell>
                    <TableCell align="right">{row.fat}</TableCell>
                    <TableCell align="right">{row.carbs}</TableCell>
                    <TableCell align="right">{row.protein}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{/*navigate(Config.BASE_URL + '/admin/corp')*/}}>▪ Corp</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} /><br />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Dessert (100g serving)</TableCell>
                  <TableCell align="right">Calories</TableCell>
                  <TableCell align="right">Fat&nbsp;(g)</TableCell>
                  <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                  <TableCell align="right">Protein&nbsp;(g)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.calories}</TableCell>
                    <TableCell align="right">{row.fat}</TableCell>
                    <TableCell align="right">{row.carbs}</TableCell>
                    <TableCell align="right">{row.protein}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '12px' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{/*navigate(Config.BASE_URL + '/admin/service_and_product')*/}}>▪ Service & Product</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} />
          <div style={{ width: '100%', height: '300px', marginTop: '16px', marginBottom: '16px' }}><Line options={options} data={data} width={'100%'} /></div>
          Total: 16,220,700<br /><br />
          Android: 16,220,700<br /><br />
          iOS: 16,220,700<br /><br />
        </Paper>
        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{ /*navigate(Config.BASE_URL + '/admin/billing')*/ }}>▪ Billing</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} /><br />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Dessert (100g serving)</TableCell>
                  <TableCell align="right">Calories</TableCell>
                  <TableCell align="right">Fat&nbsp;(g)</TableCell>
                  <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                  <TableCell align="right">Protein&nbsp;(g)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.calories}</TableCell>
                    <TableCell align="right">{row.fat}</TableCell>
                    <TableCell align="right">{row.carbs}</TableCell>
                    <TableCell align="right">{row.protein}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px' }}>
          <span style={{cursor:'pointer'}} onClick={()=>{/*navigate(Config.BASE_URL + '/admin/inquiry/corp')*/}}>▪ Corp Inquiry</span><br /><hr style={{ height: '1px', border: 'none', backgroundColor: '#a2a2a2', color: '#888888' }} /><br />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Dessert (100g serving)</TableCell>
                  <TableCell align="right">Calories</TableCell>
                  <TableCell align="right">Fat&nbsp;(g)</TableCell>
                  <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                  <TableCell align="right">Protein&nbsp;(g)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.calories}</TableCell>
                    <TableCell align="right">{row.fat}</TableCell>
                    <TableCell align="right">{row.carbs}</TableCell>
                    <TableCell align="right">{row.protein}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <div style={{ height: '600px' }}>&nbsp;&nbsp;</div>


















        <div style={{ display: 'none' }}><TextField
          label="With normal TextField"
          id="standard-start-adornment"
          sx={{ m: 1, width: '25ch' }}
          InputProps={{
            startAdornment: <InputAdornment position="start">kg</InputAdornment>,
          }}
          variant="standard"
        />
          <FormControl variant="standard" sx={{ m: 1, mt: 3, width: '25ch' }}>
            <Input
              id="standard-adornment-weight"
              endAdornment={<InputAdornment position="end">kg</InputAdornment>}
              aria-describedby="standard-weight-helper-text"
              inputProps={{
                'aria-label': 'weight',
              }}
            />
            <FormHelperText id="standard-weight-helper-text">Weight</FormHelperText>
          </FormControl>
          <FormControl sx={{ m: 1, width: '25ch' }} >

            <Input
              id="standard-adornment-password"
              type={'password'}
              disableUnderline

              sx={{
                '& input::placeholder': {
                  minHeight: '48x',
                  fontSize: '13px',
                  paddingTop: '-4px',
                  color: '#ff0000',
                  paddingTop: '-19px !important'
                },
              }}

              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    sx={{ fontSize: 11 }}

                  >
                    <VisibilityOff style={{ fontSize: 18 }} />
                  </IconButton>
                </InputAdornment>
              }


              placeholder='패스워드'

              style={{ height: '48px', backgroundColor: '#f8f8f8', borderRadius: '8px', padding: '4px', paddingTop: '8px', paddingLeft: '12px' }}
            />
          </FormControl>
          <FormControl fullWidth sx={{ m: 1 }} variant="standard">
            <InputLabel htmlFor="standard-adornment-amount">Amount</InputLabel>
            <Input
              id="standard-adornment-amount"
              startAdornment={<InputAdornment position="start">$</InputAdornment>}
            />
          </FormControl>

          <TextField
            required
            id="outlined-required"
            style={{ fontSize: '13px', minHeight: '36px', borderColor: '#ffffff' }}
            disableUnderline
            placeholder='test'
            defaultValue="Hello World"
          />
          <TextField
            id="standard-multiline-flexible"
            label="Multiline"
            multiline
            disableUnderline
            variant="standard"
          />

          <TextField
            placeholder="Password"
            variant="outlined"
            style={{ height: '42px', width: '200px' }}
            InputProps={{
              sx: {
                height: '42px',
                fontSize: '13px',
                '&.MuiOutlinedInput-root': {
                  backgroundColor: '#f8f8f8',  // Set grey background
                  '& fieldset': {
                    border: 'none',              // Remove border even when focused
                  },
                  '&:hover fieldset': {
                    border: 'none',              // Remove border on hover
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none',              // Remove border when focused
                  },
                },
                '::placeholder': {
                  fontSize: '12px',              // Set placeholder font size
                },
              },


              endAdornment: (
                <InputAdornment position="end" sx={{ paddingRight: '8px' }}>
                  <IconButton

                    edge="end"
                    sx={{ padding: 0 }} // Optional: adjust icon padding
                  >
                    <VisibilityOff sx={{ fontSize: '18px' }} />
                  </IconButton>
                </InputAdornment>
              ),


            }}
            sx={{
              '& .MuiInputBase-input::placeholder': {
                fontSize: '12px',                // Ensure placeholder font size
              },
            }}


          />


          <TextField
            placeholder="Password"
            variant="outlined"
            style={{ height: '42px', width: '200px' }}
            InputProps={{
              sx: {
                height: '42px',
                fontSize: '13px',
                '&.MuiOutlinedInput-root': {
                  backgroundColor: '#f8f8f8',  // Set grey background
                  '& fieldset': {
                    border: 'none',              // Remove border even when focused
                  },
                  '&:hover fieldset': {
                    border: 'none',              // Remove border on hover
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none',              // Remove border when focused
                  },
                },
                '::placeholder': {
                  fontSize: '12px',              // Set placeholder font size
                },
              },


              startAdornment: (
                <InputAdornment position="start" sx={{ paddingRight: '8px' }}>
                  <IconButton

                    edge="end"
                    sx={{ padding: 0 }} // Optional: adjust icon padding
                  >
                    <VisibilityOff sx={{ fontSize: '18px' }} />
                  </IconButton>
                </InputAdornment>
              ),


            }}
            sx={{
              '& .MuiInputBase-input::placeholder': {
                fontSize: '12px',                // Ensure placeholder font size
              },
            }}


          />
          <br />
          <Button onClick={() => { post_test() }}>POST</Button>
        </div>
      </div>
    </>
  );

}